"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createRequestClient;
const add_basic_auth_header_1 = __importDefault(require("./middleware/before-request/add-basic-auth-header"));
const prepare_headers_1 = __importDefault(require("./middleware/after-response/prepare-headers"));
const prepare_response_1 = __importDefault(require("./middleware/after-response/prepare-response"));
const request_client_1 = __importDefault(require("./request-client"));
const baseClient = (0, request_client_1.default)({
    headers: {
        'user-agent': 'Segment (Actions)'
    },
    beforeRequest: [
        add_basic_auth_header_1.default
    ],
    afterResponse: [prepare_response_1.default, prepare_headers_1.default]
});
function createRequestClient(...requestOptions) {
    let client = baseClient;
    for (const options of requestOptions ?? []) {
        client = client.extend(options);
    }
    return (url, options) => {
        return client(url, options);
    };
}
//# sourceMappingURL=create-request-client.js.map